import Http from './Http';

export const validateToken = async (token: string) => {
  return Http.get(`token/validate`, {
    params: { token }
  });
};
